import React from 'react';
import TableHeadContainer, { Header } from '../../../../../components/Table/TableHead';
import { RequestQuerySortTypesEnum } from '../../../../../consts/enums';

export type MatchFlowLogsTableHeaderProps = {
  headers: Header[],
}

export const MatchFlowLogsTableHeader = ({ headers }: MatchFlowLogsTableHeaderProps):JSX.Element => {
  return (
    <TableHeadContainer
      headers={ headers }
      orderHandler={ () => { /* */ } }
      order={ {
        updateAt: RequestQuerySortTypesEnum.Ascendant,
      } }
    />
  );
};
